import httpManager from "@/app/shared/utils/httpManager";

export default async function (params, endpoint) {
  const entity = params?.entity;
  const portfolio = params?.portfolio || "";
  const date_start = params?.date_start || "";
  const date_end = params?.date_end || "";
  const queue = params?.queue || null;
  let url = `/dashboard/${endpoint}/excel/?`;

  if (entity !== undefined) url += `entity=${entity ?? ""}&`;
  if (portfolio) url = url + `portfolio=${portfolio}&`;
  if (date_start) url = url + `date_start=${date_start}&`;
  if (date_end) url = url + `date_end=${date_end}&`;
  if (queue) url = url + `queue=${queue}`;

  const response = await httpManager.getBlob(url);
  return response;
}
